exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/** 常用色值 **/\n/** 常用字体大小 **/\n.header-content {\n  background-color: #ffffff;\n  border-bottom: 1px solid #e3e3e3;\n}\n.header-content .header-row {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  height: 60px;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.header-content .header-row .shop-col {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  width: 100%;\n}\n.header-content .header-row .shop-col .shop-continaer {\n  padding: 0 20px;\n}\n.header-content .header-row .shop-col .shop-continaer2 {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 0 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js!./src/components/Header/index.less
// module id = 606
// module chunks = 0